export default __webpack_public_path__ + "static/media/pin-hover.b17fe2d3.png";